import {  PMREMGenerator, Texture,   WebGLRenderer, Scene } from 'three'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js'

export class EnvManager {
  private defaultEnv?: Texture
  private current?: Texture
  private intensity: number = 0.5

  constructor(private scene: Scene) {}

  initDefault(renderer: WebGLRenderer, intensity = 0.5) {
    if (this.defaultEnv) return

    const pmrem = new PMREMGenerator(renderer)
    pmrem.compileEquirectangularShader()

    this.defaultEnv = pmrem.fromScene(new RoomEnvironment()).texture
    this.scene.environment = this.defaultEnv
    this.scene.environmentIntensity = intensity
    this.intensity = intensity
    pmrem.dispose()
  }

  /** HDR 进入时调用 */
  useHDR(hdrTex: Texture, renderer: WebGLRenderer, intensity?: number) {
    this.current = hdrTex
    const pmrem = new PMREMGenerator(renderer)
    const envMap = pmrem.fromEquirectangular(hdrTex).texture

    this.scene.environment = envMap
    if (intensity !== undefined)
      this.scene.environmentIntensity = intensity

    pmrem.dispose()
  }

  /** HDR 退出时调用 */
  restoreDefault() {
    if (!this.defaultEnv) return
    this.scene.environment = this.defaultEnv
    this.scene.environmentIntensity = this.intensity
    
  }
}